import React from 'react';
import styled from 'styled-components';

const MegaCreditBox = ({ children }) => {
  return (
    <Wrapper>
      <div className="octagon">
        <div className="num-wrap">
          <svg width="100" height="100" viewBox="0 0 100 100">
            <text x="50" y="50" textAnchor="middle" dy=".3em">
              {children}
            </text>
          </svg>
        </div>
      </div>
      <div className="top" />
      <div className="left" />
      <div className="right" />
      <div className="bottom" />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  overflow: hidden;
  width: 40px;
  height: 40px;
  float: left;
  position: relative;

  .octagon {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: hidden;
  }
  .octagon:before {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transform: rotate(45deg) scale(1.2);
    background: linear-gradient(to bottom right, yellow, gold, goldenrod);
    content: '';
  }
  .num-wrap {
    position: absolute;
    display: grid;
    place-content: center;
    width: 100%;
    height: 100%;
  }
  svg {
    width: 100%;
    height: 100%;
    fill: black;
    font-size: 2.5rem;
    font-weight: bold;
  }
  .top,
  .left,
  .right,
  .bottom {
    position: absolute;
    box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.2);
    width: 50%;
    height: 50%;
    z-index: 10;
    border-radius: 10%;
  }
  .top {
    top: -35%;
    left: 25%;
    box-shadow: inset -2px 2px 5px rgba(215, 215, 215, 0.5),
      inset -1px 1px 5px rgba(215, 215, 215, 0.5);
  }
  .left {
    top: 25%;
    left: -35%;
    box-shadow: inset 2px 2px 5px rgba(154, 147, 140, 0.5),
      inset 1px 1px 5px rgba(200, 180, 140, 0.5);
  }
  .right {
    top: 25%;
    left: 85%;
    box-shadow: inset -2px 2px 5px rgba(154, 147, 140, 0.5),
      inset -1px 1px 5px rgba(200, 180, 140, 0.5);
  }
  .bottom {
    bottom: -35%;
    left: 25%;
    box-shadow: inset -2px 2px 5px rgba(154, 147, 140, 0.5),
      inset -1px 1px 5px rgba(200, 180, 140, 0.5);
  }
`;

export default MegaCreditBox;
